export const STATUSES = ["Not Started", "Drafted", "Under Review", "Approved", "Uploaded to NABL Portal", "Implemented & Verified"];
export const STATUS_STYLE = {
  "Not Started": "bg-slate-100 text-slate-600 border-slate-200",
  Drafted: "bg-violet-50 text-violet-700 border-violet-200",
  "Under Review": "bg-blue-50 text-blue-700 border-blue-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Uploaded to NABL Portal": "bg-amber-50 text-amber-700 border-amber-200",
  "Implemented & Verified": "bg-[#2E9B65] text-white border-[#2E9B65]",
  Draft: "bg-violet-50 text-violet-700 border-violet-200",
  "Revision Required": "bg-red-50 text-red-700 border-red-200",
  Effective: "bg-[#2E9B65] text-white border-[#2E9B65]",
  Superseded: "bg-slate-100 text-slate-500 border-slate-200",
  Obsolete: "bg-slate-100 text-slate-500 border-slate-200",
  Open: "bg-red-50 text-red-700 border-red-200",
  Closed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Done: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  Planned: "bg-violet-50 text-violet-700 border-violet-200",
  Verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Pending Verification": "bg-amber-50 text-amber-700 border-amber-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
};
export const CHAPTERS = [
  { key: "4", label: "4 General" }, { key: "5", label: "5 Structural & Governance" }, { key: "6", label: "6 Resources" },
  { key: "7", label: "7 Processes" }, { key: "8", label: "8 Management System" }, { key: "A", label: "Annex A POCT" },
];
export const DOC_TYPES = ["Policy", "SOP", "Work Instruction", "Manual", "Format-Record", "Agreement", "Plan", "Register"];
export const ROLE_OPTIONS = [
  ["lab_admin", "Laboratory Administrator"], ["lab_director", "Laboratory Director"], ["quality_manager", "Quality Manager"],
  ["technical_manager", "Technical Manager / Department Head"], ["document_preparer", "Document Preparer"],
  ["reviewer_approver", "Reviewer / Approver"], ["auditor", "Auditor"], ["read_only", "Read-Only User"],
];
export const SECTIONS = ["Clinical Biochemistry", "Clinical Pathology", "Haematology", "Immunohaematology", "Microbiology & Serology", "Histopathology",
  "Cytopathology", "Flow Cytometry", "Molecular Diagnostics", "Histocompatibility & Immunogenetics", "Cytogenetics", "POCT"];
export const STATES = ["Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh",
  "Jammu & Kashmir", "Jharkhand", "Karnataka", "Kerala", "Ladakh", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha",
  "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Chandigarh",
  "Andaman & Nicobar", "Dadra & Nagar Haveli and Daman & Diu", "Lakshadweep"];
export const QUALIFICATIONS = ["MD Pathology", "MD Microbiology", "MD Biochemistry", "DNB Pathology", "DCP", "PhD (Life Sciences)", "MSc Medical Lab Technology", "MSc (Biochemistry/Microbiology)", "BSc MLT", "DMLT", "MBBS", "Other"];
export const READINESS_COLORS = {
  "Not Assessed": "#94A3B8", "Gap Identified": "#D64545", "Documentation Pending": "#E7A23B", "Awaiting Review": "#2563EB",
  "Awaiting Implementation": "#7C3AED", "Awaiting Evidence": "#F59E0B", "Awaiting Verification": "#0EA5E9", "Internally Verified": "#2E9B65", "Not Applicable": "#CBD5E1",
};
export const fmtDate = (s) => (s ? new Date(s.length <= 10 ? s + "T00:00:00" : s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
